import { withViewModel } from '../../../../../../infrastructure/components/with-view-model';
import { IUrlRedirectionFormProps, UrlRedirectionFormVM } from './url-redirection-form.viewmodel';
import { UrlRedirectionFormPresentation } from './url-redirection-form.presentation';

const UrlRedirectionFormContainer = withViewModel(UrlRedirectionFormPresentation,
    (props: IUrlRedirectionFormProps) => new UrlRedirectionFormVM(props));

export { UrlRedirectionFormContainer as UrlRedirectionForm };